import React from "react";
import ReactApexChart from "react-apexcharts";
import { CheckMarkIcon } from "../assets/icons";

const categories = [
    "Hr core",
    "Timesheets",
    "Leave",
    "Onboarding",
    "Performance",
    "Recruitment",
];

const chartData = {
    series: [
        {
            name: "Usage",
            data: [80, 40, 60, 85, 38, 55], // your values still drive bar height
        },
    ],
    options: {
        chart: {
            type: "bar",
            height: 200,
            toolbar: { show: false },
        },
        legend: {
            show: false,
        },
        plotOptions: {
            bar: {
                columnWidth: "80%",
                borderRadius: 0,
                distributed: true,
                dataLabels: {
                    position: "top",
                },
            },
        },
        dataLabels: {
            enabled: true,
            offsetY: -20, // shift above bar
            style: {
                fontSize: "12px",
                colors: ["#000"],
            },
            formatter: function (val, opts) {
                // show the category name instead of the number
                return categories[opts.dataPointIndex];
            },
        },
        colors: ["#3b82f6"],
        xaxis: {
            categories: "", // normal category axis
            labels: {
                show: false, // hide bottom labels if you want only on top
            },
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            show: false,
        },
        grid: {
            show: false,
        },
        tooltip: {
            enabled: true,
        },
    },
};

export default function UsageHealthTab() {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Feature Adoption with ApexChart */}
            <div className="chart-card">
                <h2 className="text-span text-black !font-semibold mb-0 mb-4">Feature Adoption</h2>
                <ReactApexChart
                    options={chartData.options}
                    series={chartData.series}
                    type="bar"
                    height={300}
                />
            </div>

            {/* Login Activity Trends */}
            <div className="chart-card">
                <h2 className="text-span text-black !font-semibold mb-0 mb-4">Login Activity Trends</h2>
                <div className="flex items-center h-48 justify-center text-gray-600">
                    No login activity
                </div>
            </div>

            {/* Bottom Row */}
            <div className="col-span-1 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 mt-2 lg:col-span-2">
                {/* Health Score */}
                <div className="chart-card">
                    <h2 className="text-span text-black !font-semibold mb-0 mb-4">Health score breakdown</h2>
                    <div className="mb-8">
                        <div className="flex justify-between text-sm mb-3 font-medium">
                            <span className="font-medium">User management</span>
                            <span className="font-medium text-[#5C5B62]">87%</span>
                        </div>
                        <div className="w-full h-[10px] bg-gray-100 rounded mb-2">
                            <div
                                className="h-[10px] bg-green-500 rounded"
                                style={{ width: "87%" }}
                            ></div>
                        </div>
                    </div>
                    <div className="mb-8">
                        <div className="flex justify-between text-sm mb-3 font-medium">
                            <span className="font-medium">Feature utilisation</span>
                            <span className="font-medium text-[#5C5B62]">57%</span>
                        </div>
                        <div className="w-full h-[10px] bg-gray-100 rounded mb-2">
                            <div
                                className="h-[10px] bg-lime-300 rounded"
                                style={{ width: "57%" }}
                            ></div>
                        </div>
                    </div>
                    <div className="mb-8">
                        <div className="flex justify-between text-sm mb-3 font-medium">
                            <span className="font-medium">Support satisfaction</span>
                            <span className="font-medium text-[#5C5B62]">94%</span>
                        </div>
                        <div className="w-full h-[10px] bg-gray-100 rounded mb-2">
                            <div
                                className="h-[10px] bg-yellow-400 rounded"
                                style={{ width: "94%" }}
                            ></div>
                        </div>
                    </div>

                    <div className="mb-8">
                        <div className="flex justify-between text-sm mb-3 font-medium">
                            <span className="font-medium">Payment history</span>
                            <span className="font-medium text-[#5C5B62]">100%</span>
                        </div>
                        <div className="w-full h-[10px] bg-gray-100 rounded">
                            <div
                                className="h-[10px] bg-green-500 rounded"
                                style={{ width: "100%" }}
                            ></div>
                        </div>
                    </div>
                </div>

                {/* Usage Statistics */}
                <div className="chart-card">
                    <h2 className="text-span text-black !font-semibold mb-0 mb-4">Usage Statistics</h2>
                    <ul class="space-y-4 text-sm text-gray-600">
                        <li class="text-span font-semibold text-black">
                            <span class="text-span font-medium text-[#4F4B45]">Total Logins (30d):</span>
                            1,642
                        </li>
                        <li class="text-span font-semibold text-black">
                            <span class="text-span font-medium text-[#4F4B45]">Average Session Duration:</span>
                            24 mins
                        </li>
                        <li class="text-span font-semibold text-black">
                            <span class="text-span font-medium text-[#4F4B45]">Active Features:</span>
                            6 of 8
                        </li>
                        <li class="text-span font-semibold text-black">
                            <span class="text-span font-medium text-[#4F4B45]">Data Volume:</span>
                            2.3GB
                        </li>
                        <li class="text-span font-semibold text-black">
                            <span class="text-span font-medium text-[#4F4B45]">API Calls (30d):</span>
                            45,535
                        </li>
                        <li class="text-span font-semibold text-black">
                            <span class="text-span font-medium text-[#4F4B45]">Integration Usage:</span>
                            High
                        </li>
                    </ul>


                </div>

                {/* Risk Indicators */}
                <div className="chart-card">
                    <h2 className="text-span text-black !font-semibold mb-0 mb-4">Risk Indicators</h2>
                    <div className="bg-green-50 rounded-lg flex items-start p-3 mb-3">
                        <div className="flex items-center justify-center h-6 w-6 mr-2 mt-1">
                            <span className="bg-green-500 rounded-full w-4 h-4 flex items-center justify-center text-white text-xs">
                                ✓
                            </span>
                        </div>
                        <div>
                            <div className="font-semibold text-sm text-black">
                                Low risk engagement
                            </div>
                            <div className="text-xs text-gray-500">
                                All engagement metrics are healthy
                            </div>
                        </div>
                    </div>
                    <ul className="text-sm">
                        <li className="flex items-center mb-4">
                            Login frequency normal
                            <span className="ml-auto text-blue-500">{CheckMarkIcon}</span>
                        </li>
                        <li className="flex items-center mb-4">
                            Payment current
                            <span className="ml-auto text-blue-500">{CheckMarkIcon}</span>
                        </li>
                        <li className="flex items-center mb-4">
                            Support satisfaction high
                            <span className="ml-auto text-blue-500">{CheckMarkIcon}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
